import { BenefitFormData } from '@/types/circuits/CircuitDaysFormData';
import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { findNextAvailableStepIndex } from './findNextAvailableStepIndex';
import { hasActiveAssociatedBenefits } from './hasActiveAssociatedBenefits';
import { isRowReservedForAssociatedBenefits } from './isRowReservedForAssociatedBenefits';
import { stepHasOtherStandardBenefits } from './stepHasOtherStandardBenefits';

export const getAccommodationTargetStepIndex = (
  candidateIndex: number,
  steps: CircuitDayFormData['steps'],
  accommodationBenefit?: BenefitFormData,
): number => {
  if (!hasActiveAssociatedBenefits(accommodationBenefit?.hotel)) {
    return candidateIndex;
  }

  let index = Math.max(candidateIndex, 0);

  while (
    index < steps.length &&
    (isRowReservedForAssociatedBenefits(steps[index]) ||
      stepHasOtherStandardBenefits(steps[index]))
  ) {
    index = findNextAvailableStepIndex(index + 1, steps);
  }

  return index;
};
